<template lang="pug">
v-container.report-info-user
  base-text-divider 回報資料
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 繳款者：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.displayName }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 匯款時間：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.transferDate | timestampFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 繳交總額：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.total }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 帳號後五碼：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.lastFiveNumber || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 銀行名稱：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.bankname || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 是否需要寄送紙本收據：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.needPaper | boolean }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 回報單id：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.temp.id }}
  base-text-divider 繳費項目
  v-layout(
    wrap
    justify-start)
    v-flex.text-xs-left(
      v-for="item in items"
      xs6)
      receipt-item-chip(
        :year="item.year"
        :text="item | receiptItemFilter")
  base-text-divider 總額
  .text-xs-center.red--text.title {{ report.total }}
</template>
<script>
import { db } from "@/firebase";
import { formMixin } from "@/mixins";
import ReceiptItemChip from "@/components/core/ReceiptItemChip.vue";

export default {
  name: "ReportInfoUser",
  mixins: [formMixin],
  components: {
    ReceiptItemChip
  },
  props: {
    report: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      settleForm: false,
      items: this.report.items
    };
  },
  methods: {
    /* 待開發
    async submit() {
      await this.formMixin_submit(['payer', 'items', 'needPaper', 'paperInvoiced'], 'post', 'receipt')
    }
    */
  }
};
</script>
